import { Col, Container, Row } from "react-bootstrap"

function LogoHeader() {
    return <Container fluid >
        <Row>
            <Col className="text-center">
                <img width={300} src='/Logo_hydro.jpg' alt="hydro logo" />
            </Col>
        </Row>
    </Container>
}

export default LogoHeader